import client from './client';

const API_BASE_URL = process.env.VUE_APP_BASE_URL || 'http://localhost:8090/api';

export const notificationAPI = {
  // Get notifications for the current user
  getNotifications(params = {}) {
    const queryParams = new URLSearchParams();
    if (params.limit) queryParams.append('limit', params.limit);
    if (params.offset) queryParams.append('offset', params.offset);
    
    const url = `${API_BASE_URL}/notifications${queryParams.toString() ? '?' + queryParams.toString() : ''}`;
    return client.get(url);
  },

  // Get unread notification count
  getUnreadCount() {
    return client.get(`${API_BASE_URL}/notifications/unread-count`);
  },

  // Mark a notification as read
  markAsRead(notificationId) {
    return client.put(`${API_BASE_URL}/notifications/${notificationId}/read`, {
      notification_id: notificationId
    });
  },

  // Mark all notifications as read
  markAllAsRead() {
    return client.put(`${API_BASE_URL}/notifications/mark-all-read`);
  }
};

export default notificationAPI;
